import React, { useState, useEffect, useContext } from "react";
import sendRequest from "../utils/sendRequest";
import validators from "../utils/validators";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Navbar from "../components/Navbar";
import swal from "sweetalert";
import Loader from "../components/Loader";
import { checkAuth } from "../utils/checkAuth";
import AMCReg from "./AMCReg";
import Rtareg from "./Rtareg";
import { UserTypeContext } from "../MyContext";
import Sebi_Registration from "./Sebi_Registration";
import SecureLS from "secure-ls";
import { encrypt } from "../utils/cipher";

const domains = {
  SEBIUSER: "sebi.gov.in",
  KFIN: "kfintech.com",
  CAMS: "cams.com",
};

const useStyles = makeStyles((theme) => ({
  root: {
    height: {
      md: "80%",
      xs: "60%"
    },

    marginTop: 40,
    maxHeight: 600,
    marginLeft: "15%",
    width: 800,
    maxWidth: 900,
    borderRadius: 5,
    boxShadow: "0px 3px 15px #BCB0B0",
    background: " #EEEEEE",
    display: "flex",
    justifyContent: "space-evenly",
  },
  textFieldBox: {
    display: "flex",
    flexDirection: "column",
    fontFamily: "Roboto-Bold",
    fontSize: "16px",
    lineHeight: "19px",
    color: "#272782",
    width: "35%",
    marginBottom: "25px",
  },
  rowContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    width: "100%",
  },

  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    height: "70%"
  },
  title: {
    display: "flex",
    alignItems: "center",
    color: "#272782",
    fontWeight: "400",
    height: "45px",
    left: "702px",
    top: "340px",
    fontFamily: "Roboto-Medium",
    fontStyle: "normal",
    fontSize: "36px",
    lineHeight: "42px",
  },

  [theme.breakpoints.down("md")]: {
    root: {
      height: "50%",
      marginTop: 10,
      maxHeight: 650,
      marginLeft: "0%",
      width: "100%",
      maxWidth: 900,
      borderRadius: 5,
      boxShadow: "0px 3px 15px #BCB0B0",
      background: " #EEEEEE",
      display: "flex",
      justifyContent: "space-evenly",
    },
  },

  [theme.breakpoints.down("xs")]: {
    root: {
      height: "60%",
      marginTop: 10,
      maxHeight: 650,
      marginLeft: "5%",
      width: "90%",
      maxWidth: 900,
      borderRadius: 5,
      boxShadow: "0px 3px 15px #BCB0B0",
      background: " #EEEEEE",
      display: "flex",
      justifyContent: "space-evenly",
    },
    rowContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      alignItems: "center",
      width: "100%",
    },
    textFieldBox: {
      display: "flex",
      flexDirection: "column",
      fontFamily: "Roboto-Bold",
      fontSize: "16px",
      lineHeight: "19px",
      color: "#272782",
      width: "75%",
      marginBottom: "25px",
    },
  },
}));

let styles = {
  title: {
    display: "flex",
    alignItems: "center",
    color: "#272782",
    fontWeight: "400",
    height: "45px",
    left: "702px",
    top: "340px",
    fontFamily: "Roboto-Medium",
    fontStyle: "normal",
    fontSize: "36px",
    lineHeight: "42px",
  },
};
const theme = createTheme();

function Register() {
  const initialState = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    mobile: "",
    userType: "",
    PMSName: ""
  };
  const ls = new SecureLS();
  const userType = ls.get("userType");
  const [input, setInput] = useState(initialState);
  const [loader, setLoader] = useState(false);
  let navigate = useNavigate();
  // console.log(">>>>>>>>>>>>>>>>>>>>>>", useContext(UserTypeContext))
  // useEffect(() => {
  //   (async () => {
  //     let authenticated = await checkAuth();
  //     if (!authenticated) navigate("/Login");
  //   })();
  // }, []);

  function handleChange(event) {
    const { name, value } = event.target;

    setInput((prevInput) => ({
      ...prevInput,
      [name]: value,
    }));
  }

  // -----------------------SubmitHandler---------------------
  const handleSubmit = (input) => {
    setLoader(true);
    console.log("vv",input);
    // const isValid = validateFields(input);
    if (true) {
      // console.log(input)
      let encryptedPayload = encrypt(input)
      sendRequest("api/auth/register", { payload: encryptedPayload })
        .then((result) => {
          // console.log(result);
          if (result.type === "success") {
            setInput(initialState); // Reset input to initial state
            setLoader(false);
            swal("Done", "User Registered Successfully", "success");
          } else {
            setLoader(false);
            swal("", result.message, "warning");
          }
        })
        .catch((error) => {
          setLoader(false);
          swal("", error, "error");
        });
    } else {
      setLoader(false);
      swal("", "Please fill all fields correctly", "warning");
    }
    // console.log("button clicked");
  };

  function validateFields(login) {
    let validEmail = validators.validateEmail(login.email);
    let validPassword = validators.validatePassword(login.password);
    let validPhone = validators.validatePhoneNumber(login.mobile);
    let validUser = validators.validateUserType(
      login.userType,
      domains,
      login.email
    );

    if (!validEmail.isValid) swal("", validEmail.message, "warning");
    else if (!validPassword.isValid) swal("", validPassword.message, "warning");
    else if (!validPhone.isValid) swal("", validPhone.message, "warning");
    else if (!validUser.isValid) swal("", validUser.message, "warning");

    return (
      validEmail.isValid &&
      validPhone.isValid &&
      validPassword.isValid &&
      validUser.isValid
    );
  }

  const autoSelectUser = () => {
    const domain = input.email.split("@")[1];
    let user = "";

    if (domain === domains.SEBIUSER) user = "SEBIUSER";
    else if (domain === domains.KFIN || domain === domains.CAMS) user = "APMII";
    else user = "PMS";

    setInput((prevInput) => ({
      ...prevInput,
      userType: user,
    }));
  };

  const cardStyles = useStyles(theme);

  return (
    <ThemeProvider theme={theme}>
      <Navbar />
      <Loader visible={loader} />
      <Container fixed sx={{ display: "flex", justifyContent: "center", height: "70%", alignItems: "center" }}>
        {userType == "PMS" &&
          <AMCReg
            handleSubmit={handleSubmit} />
        }
        {userType == "APMII" &&
          <Rtareg
            handleSubmit={handleSubmit} />
        }
        {userType == "SEBI" &&
          <Sebi_Registration
            handleSubmit={handleSubmit} />
        }
      </Container>
    </ThemeProvider>
  );
}

export default Register;
